<template>
	<div class="watch-options-devices">
		<spinner v-if="devices.loading"/>
		<div class="idi-table devices" v-if="!devices.loading">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.imei') }}</div>
				<div class="idi-cell">{{ $t('labels.general.name') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row" v-for="device in devices.data" :key="device.id">
				<div class="idi-cell">{{ device.uid }}</div>
				<div class="idi-cell">{{ device.name }}</div>
				<div class="idi-cell align-right"><button class="btn btn-small btn-round" @click="detachDevice(device.id)">{{ $t('buttons.general.detach') }}</button></div>
			</div>
		</div>
		<div class="actions" v-if="!devices.loading">
			<button-icon-text-loading @click.native="openModal" icon="check">{{ $t('buttons.general.attach') }}</button-icon-text-loading>
		</div>
		<watch-options-form-attach-device v-if="modalBox.open" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal"/>
	</div>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
import DeviceCollection from '@/classes/DeviceCollection'
import WatchOptionsFormAttachDevice from './WatchOptionsFormAttachDevice'
export default {
	components: {
		WatchOptionsFormAttachDevice
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			name: 'watch options devices',
			devices: new ApiCollection(),
			modalBox: {
				open: false
			}
		}
	},
	methods: {
		getDevices () {
			this.devices.loading = true
			this.$api.patients.devices.getAll(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info(this.name, 'patients.devices.getAll OK', response)()
					this.devices.data = new DeviceCollection(response.body)
				}).catch(error => {
					this.$log.error(this.name, 'patients.devices.getAll ERROR', error)()
					this.devices.error = error
				}).finally(() => {
					this.devices.loading = false
				})
		},
		detachDevice (device_id) {
			this.$api.patients.devices.detach(this, this.user_uid, this.watch_id, device_id)
				.then(response => {
					this.$log.info(this.name, 'patients.devices.detach OK', response)()
					this.getDevices()
				}).catch(error => {
					this.$log.error(this.name, 'patients.devices.detach ERROR', error)()
				})
		},
		openModal () {
			this.modalBox.open = true
		},
		closeModal (params) {
			this.modalBox.open = false
			if (params.reload) {
				this.getDevices()
			}
		}
	},
	created () {
		this.getDevices()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/options/WatchOptionsDevices.vue